import { render, staticRenderFns } from "./PatrimonialSheetOneSheet.vue?vue&type=template&id=6241054c&scoped=true&"
import script from "./PatrimonialSheetOneSheet.vue?vue&type=script&lang=ts&"
export * from "./PatrimonialSheetOneSheet.vue?vue&type=script&lang=ts&"
import style0 from "./PatrimonialSheetOneSheet.vue?vue&type=style&index=0&id=6241054c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6241054c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VContainer,VDataIterator,VDivider,VList,VListItem,VListItemContent,VRow,VSkeletonLoader})
